/* unplugin-vue-components disabled */import script from "./SupportTrendChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportTrendChart.vue?vue&type=script&setup=true&lang=js"

import "./SupportTrendChart.vue?vue&type=style&index=0&id=21b93032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b93032"]])

export default __exports__